/**
 * KARVA Pakete im Konfigurator (2026-10). Link: ...?configure=true&paket=hochzeit|geburt|weihnachten|trauer|bestatter
 * Hakt je Paket Verpackung, Gravur, Wandhalterung (vormontiert), Bildaufsteller oder Erinnerungsset vor,
 * wählt die Größe und hängt "Paket" ans Bild. Wandhalterung gratis: Rabatt "Paket: Wandhalterung inklusive".
 */
(function () {
  'use strict';

  var PAKETE = {
    hochzeit: { name: 'Hochzeitspaket', shortSide: 40, gift: true, engrave: true, mount: true,
      l1: 'z. B. Anna & Tom', l2: 'z. B. 12.06.2027',
      note: 'Größe 60 × 40 cm (je nach Foto leicht angepasst), Geschenkverpackung mit Grußkarte und Gravur sind vorausgewählt. Die Wandhalterung ist inklusive und schon vormontiert.' },
    geburt: { name: 'Geburtspaket', shortSide: 30, gift: true, engrave: true, mount: true,
      l1: 'z. B. Emma Sophie', l2: 'z. B. 03.10.2026 · 3420 g',
      note: 'Größe 45 × 30 cm (je nach Foto leicht angepasst), Geschenkverpackung mit Grußkarte und Gravur sind vorausgewählt. Die Wandhalterung ist inklusive und schon vormontiert.' },
    weihnachten: { name: 'Weihnachtspaket', shortSide: 40, gift: true, engrave: true, mount: true,
      l1: 'z. B. Frohe Weihnachten', l2: 'z. B. Eure Lena · 2026',
      note: 'Größe 60 × 40 cm (je nach Foto leicht angepasst), Geschenkverpackung mit Grußkarte und Gravur sind vorausgewählt. Die Wandhalterung ist inklusive und schon vormontiert.' },
    trauer: { name: 'Erinnerungsset', shortSide: 30, set: true,
      l1: 'z. B. In Liebe, Opa Hans', l2: 'z. B. 1938 – 2026',
      note: 'Größe 30 × 40 cm (je nach Foto leicht angepasst), die Aufstellerleiste und die Trauerkarte sind vorausgewählt. So steht das Bild bei der Trauerfeier und später zu Hause.' },
    bestatter: { name: 'Bestatter-Auftrag', shortSide: 30, set: true, formal: true,
      l1: 'z. B. In Liebe, Hans Müller', l2: 'z. B. 1938 – 2026',
      note: 'Größe 30 × 40 cm (je nach Foto leicht angepasst), die Aufstellerleiste und die Trauerkarte sind vorausgewählt. Bitte tragen Sie unten Name, Lebensdaten und das Datum der Trauerfeier ein. Express können Sie bei Bedarf dazuwählen. Ihren Partnercode geben Sie im Checkout ein.' }
  };

  var SET_HANDLE = 'erinnerungsset-zubehoer';
  var SET = null; // { variants: [{id, title, price}] }
  var STAND_HANDLE = 'zweigeteilter-bildaufsteller-aus-massivholz';
  var STAND = null; // { variants: [{id, title, price}] }

  function byId(id) { return document.getElementById(id); }
  function euro(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  var key = null;
  try { key = (new URLSearchParams(window.location.search).get('paket') || '').toLowerCase(); } catch (e) {}
  var P = key && PAKETE[key] ? PAKETE[key] : null;

  /* ---------- Bildaufsteller als Zusatz ---------- */
  function loadStand(handle) {
    if (typeof fetch !== 'function') return Promise.resolve(null);
    return fetch('/products/' + (handle || STAND_HANDLE) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return null;
        var vs = p.variants.filter(function (v) { return v.available; })
          .map(function (v) { return { id: v.id, title: v.title, price: v.price }; });
        return vs.length ? { variants: vs } : null;
      })
      .catch(function () { return null; });
  }

  function buildStand() {
    var box = document.createElement('label');
    box.className = 'karva-optimize karva-gift karva-stand';
    box.id = 'karva-stand-box';
    var opts = STAND.variants.map(function (v) {
      return '<option value="' + v.id + '">' + v.title + '</option>';
    }).join('');
    box.innerHTML =
      '<input type="checkbox" id="karva-stand">' +
      '<span style="flex:1 1 auto;min-width:0;"><strong>Bildaufsteller aus Massivholz dazu (+' + euro(STAND.variants[0].price) + ')</strong>' +
      '<small>Zweigeteilter Aufsteller für die unteren Ecken. Das Bild steht frei auf Sideboard oder Regal, bei der Trauerfeier oder am Grab.</small>' +
      '<span class="karva-gift__fields"><select id="karva-stand-variant" aria-label="Holzart">' + opts + '</select></span>' +
      '</span>';
    var cb = box.querySelector('#karva-stand');
    cb.addEventListener('change', function () { box.classList.toggle('is-on', cb.checked); });
    box.querySelector('select').addEventListener('click', function (e) { e.stopPropagation(); });
    return box;
  }

  function insertStand() {
    // Nur im Erinnerungsset / Bestatter-Auftrag anbieten, nicht bei jedem Bild
    if (!P || !(P.set || P.stand)) return;
    if (!STAND || byId('karva-stand-box')) return;
    var anchor = byId('karva-mount') || byId('karva-optimize');
    anchor = anchor ? anchor.closest('label') : null;
    if (!anchor) return;
    anchor.parentNode.insertBefore(buildStand(), anchor.nextSibling);
  }

  function standWanted() {
    var cb = byId('karva-stand'), sel = byId('karva-stand-variant');
    if (!(cb && cb.checked && STAND && sel)) return null;
    return parseInt(sel.value, 10) || null;
  }

  /* ---------- Erinnerungsset: Aufstellerleiste + Trauerkarte ---------- */
  function buildSet() {
    var f = P && P.formal;
    var box = document.createElement('label');
    box.className = 'karva-optimize karva-gift karva-set';
    box.id = 'karva-set-box';
    var opts = SET.variants.map(function (v) {
      return '<option value="' + v.id + '">' + v.title + '</option>';
    }).join('');
    box.innerHTML =
      '<input type="checkbox" id="karva-set">' +
      '<span style="flex:1 1 auto;min-width:0;"><strong>Erinnerungsset: Aufstellerleiste und Trauerkarte (+' + euro(SET.variants[0].price) + ')</strong>' +
      '<small>' + (f ? 'Die Leiste fertigen wir passend zur Bildbreite, aus Valchromat in vielen Farben oder Massivholz. Die Trauerkarte beschriften wir mit Ihren Angaben.'
                     : 'Die Leiste fertigen wir passend zur Bildbreite, aus Valchromat in vielen Farben oder Massivholz. Die Trauerkarte beschriften wir mit deinen Angaben.') + '</small>' +
      '<span class="karva-gift__fields">' +
        '<select id="karva-set-variant" aria-label="Material der Aufstellerleiste">' + opts + '</select>' +
        '<input type="text" id="karva-set-name" maxlength="40" placeholder="Name auf der Trauerkarte">' +
        '<input type="text" id="karva-set-dates" maxlength="40" placeholder="Lebensdaten, z. B. 12.03.1938 – 02.10.2026">' +
        '<textarea id="karva-set-text" maxlength="200" placeholder="Persönlicher Text (optional)"></textarea>' +
        (f ? '<input type="text" id="karva-set-feier" maxlength="40" placeholder="Datum der Trauerfeier">' : '') +
      '</span></span>';
    var cb = box.querySelector('#karva-set');
    cb.addEventListener('change', function () { box.classList.toggle('is-on', cb.checked); });
    var fields = box.querySelectorAll('select,input[type=text],textarea');
    for (var i = 0; i < fields.length; i++) {
      fields[i].addEventListener('click', function (e) { e.stopPropagation(); });
      fields[i].addEventListener('keydown', function (e) { e.stopPropagation(); });
    }
    return box;
  }

  function insertSet() {
    if (!SET || !P || !P.set || byId('karva-set-box')) return;
    var anchor = byId('karva-stand-box') || byId('karva-mount') || byId('karva-optimize');
    anchor = anchor ? (anchor.closest('label') || anchor) : null;
    if (!anchor) return;
    anchor.parentNode.insertBefore(buildSet(), anchor.nextSibling);
  }

  function val(id) { var el = byId(id); return el ? (el.value || '').trim() : ''; }

  function setItem(qty) {
    var cb = byId('karva-set'), sel = byId('karva-set-variant');
    if (!(cb && cb.checked && SET && sel)) return null;
    var props = {};
    if (val('karva-set-name')) props['Trauerkarte: Name'] = val('karva-set-name');
    if (val('karva-set-dates')) props['Trauerkarte: Lebensdaten'] = val('karva-set-dates');
    if (val('karva-set-text')) props['Trauerkarte: Text'] = val('karva-set-text');
    if (val('karva-set-feier')) props['Datum der Trauerfeier'] = val('karva-set-feier');
    return { id: parseInt(sel.value, 10), quantity: qty, properties: props };
  }

  /* ---------- Wandhalterung "inklusive" ---------- */
  function mountIncluded() {
    var g = byId('karva-gift'), e = byId('karva-engrave'), l1 = byId('karva-engrave-1'), l2 = byId('karva-engrave-2');
    var text = ((l1 && l1.value) || '').trim() || ((l2 && l2.value) || '').trim();
    return !!(g && g.checked && e && e.checked && text);
  }

  // Text der Wandhalterungs-Box (aus karva-configurator-extras.js) auf "vormontiert" umstellen
  function relabelMount() {
    var cb = byId('karva-mount');
    if (!cb) return;
    var box = cb.closest('label');
    if (!box || box.getAttribute('data-karva-relabel')) return;
    var strong = box.querySelector('strong'), small = box.querySelector('small');
    if (!strong) return;
    var m = strong.textContent.match(/\+\s*[\d.,]+\s*€/);
    strong.innerHTML = 'Wandhalterung, vormontiert (<span class="karva-mount__price">' + (m ? m[0] : '') + '</span>)';
    if (small) small.textContent = 'Wir kleben Halteplatten und Puffer schon in der Werkstatt auf. Du setzt nur noch zwei Schrauben in die Wand, von vorne ist nichts zu sehen.';
    box.setAttribute('data-karva-relabel', '1');
  }

  function refreshMountPrice() {
    relabelMount();
    var el = document.querySelector('.karva-mount__price');
    if (!el) return;
    if (!el.getAttribute('data-price')) el.setAttribute('data-price', el.textContent);
    var incl = mountIncluded();
    var txt = incl ? 'im Paket inklusive' : el.getAttribute('data-price');
    if (el.textContent !== txt) el.textContent = txt;
    var box = el.closest('label');
    if (box) box.classList.toggle('karva-mount--incl', incl);
  }

  /* ---------- Paket anwenden ---------- */
  var done = {};
  var sizeRatio = null;

  function check(id) {
    if (done[id]) return;
    var cb = byId(id);
    if (!cb) return;
    done[id] = true;
    if (!cb.checked) {
      cb.checked = true;
      cb.dispatchEvent(new Event('change', { bubbles: true }));
      var l = cb.closest('label');
      if (l) l.classList.add('is-on');
    }
  }

  function insertNote() {
    if (byId('karva-paket-note')) return;
    var anchor = byId('karva-optimize');
    anchor = anchor ? anchor.closest('label') : document.querySelector('.halftone-pricing-section');
    if (!anchor) return;
    var d = document.createElement('div');
    d.id = 'karva-paket-note';
    d.className = 'karva-paket-note';
    d.innerHTML = '<strong>' + P.name + ' gewählt</strong><span>' + P.note + (P.formal ? ' Sie können alles ändern.' : ' Du kannst alles ändern.') + '</span>';
    anchor.parentNode.insertBefore(d, anchor);
  }

  function applySize() {
    var box = byId('karva-size-presets');
    if (!box || box.style.display === 'none') return;
    var ratio = box.getAttribute('data-ratio');
    if (!ratio || ratio === sizeRatio) return;
    var btns = box.querySelectorAll('.karva-size-preset');
    // Standardgröße, deren kurze Seite dem Paket am nächsten kommt
    var best = null, bestD = 1e9;
    for (var i = 0; i < btns.length; i++) {
      var w = parseFloat(btns[i].getAttribute('data-w')), h = parseFloat(btns[i].getAttribute('data-h'));
      var d = Math.abs(Math.min(w, h) - P.shortSide);
      if (d < bestD) { bestD = d; best = btns[i]; }
    }
    sizeRatio = ratio;
    if (best) best.click();
  }

  function applyPaket() {
    insertNote();
    if (P.gift) check('karva-gift');
    if (P.engrave) check('karva-engrave');
    if (P.mount) check('karva-mount');
    if (P.stand) check('karva-stand');
    if (P.set) check('karva-set');
    var l1 = byId('karva-engrave-1'), l2 = byId('karva-engrave-2');
    if (l1 && l1.placeholder !== P.l1) l1.placeholder = P.l1;
    if (l2 && l2.placeholder !== P.l2) l2.placeholder = P.l2;
    applySize();
  }

  /* ---------- Warenkorb ---------- */
  (function wrapFetch() {
    var original = window.fetch;
    if (typeof original !== 'function') return;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof FormData !== 'undefined' &&
            init.body instanceof FormData && init.body.has('properties[_Render-Settings]')) {
          if (P) init.body.set('properties[Paket]', P.name);
          var mcb = byId('karva-mount');
          if (mcb && mcb.checked) init.body.set('properties[Wandhalterung]', 'In der Werkstatt vormontieren');
          var standId = standWanted();
          var qty = parseInt(init.body.get('quantity'), 10) || 1;
          var extra = [];
          if (standId) {
            init.body.set('properties[Bildaufsteller]', 'Ja');
            extra.push({ id: standId, quantity: qty });
          }
          var si = setItem(qty);
          if (si) {
            init.body.set('properties[Erinnerungsset]', 'Aufstellerleiste und Trauerkarte');
            if (si.properties['Datum der Trauerfeier']) init.body.set('properties[Datum der Trauerfeier]', si.properties['Datum der Trauerfeier']);
            extra.push(si);
          }
          if (extra.length) {
            var self = this, args = arguments;
            return original.apply(self, args).then(function (res) {
              if (!res || !res.ok) return res;
              return original.call(window, '/cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: extra })
              }).then(function () { return res; }, function () { return res; });
            });
          }
        }
      } catch (e) { /* den Warenkorb nie blockieren */ }
      return original.apply(this, arguments);
    };
  })();

  function injectStyles() {
    if (byId('karva-paket-styles')) return;
    var st = document.createElement('style');
    st.id = 'karva-paket-styles';
    st.textContent =
      '.karva-paket-note{align-self:stretch;box-sizing:border-box;width:100%;margin:0 0 12px;padding:12px 14px;' +
      'background:#F3F1EC;border-left:3px solid #dfb773;border-radius:4px;font-size:14px;line-height:1.45;color:#202020;}' +
      '.karva-paket-note strong{display:block;margin:0 0 3px;font-size:15px;}' +
      '.karva-mount--incl .karva-mount__price{color:#202020;font-weight:700;background:#dfb773;padding:0 6px;border-radius:3px;}' +
      '.karva-set .karva-gift__fields input,.karva-set .karva-gift__fields textarea,.karva-set select{display:block;width:100%;box-sizing:border-box;margin-top:8px;}' +
      '.karva-stand select{margin-top:8px;padding:6px 8px;border:1px solid #cfcfcf;border-radius:4px;font:inherit;background:#fff;}';
    document.head.appendChild(st);
  }

  function tick() {
    insertStand();
    insertSet();
    if (P) applyPaket();
    refreshMountPrice();
  }

  function init() {
    injectStyles();
    if (P && window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      try { Shopify.analytics.publish('karva_paket_geoeffnet', { paket: key }); } catch (e) {}
    }
    loadStand().then(function (s) { STAND = s; tick(); });
    if (P && P.set) loadStand(SET_HANDLE).then(function (s) { SET = s; tick(); });
    setInterval(tick, 500);
    document.addEventListener('input', function (e) {
      if (e.target && /^karva-engrave-/.test(e.target.id || '')) refreshMountPrice();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();